import React from "react";
import PropTypes from "prop-types";
import City from "./City";
import Company from "./Company";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

function CompanyCity({
    methods,
    name,
    rowSpacing,
    grid,
    propsCity,
    propsCompany
}) {
    return (
        <React.Fragment>
            <Grid container rowSpacing={0} columnSpacing={2}>
                <Grid item {...grid.city}>
                    <Box mt={rowSpacing}>
                        <City {...propsCity} methods={methods} />
                    </Box>
                </Grid>
                <Grid item {...grid.company}>
                    <Box mt={rowSpacing}>
                        <Company {...propsCompany} methods={methods} dependOfCity={propsCity.cityInseeCodeName} />
                    </Box>
                </Grid>
            </Grid>
        </React.Fragment>
    )
};

CompanyCity.defaultProps = {
    name: "autocomplete_companycity",
    rowSpacing: 0,
    grid: {
        city: {
            xs: 12,
            sm: 4,
        },
        company: {
            xs: 12,
            sm: 8,
        }
    },
    propsCompany: {
        label: "Votre société",
        name: "autocomplete_company",
        companyName: "company_name",
        sirenName: "siren",
        required: "Merci de saisir votre société",
        variant: "outlined",
        companyAddress: "address",
        companyZipcode: "company_zipcode",
    },
    propsCity: {
        label: "Votre ville",
        name: "autocompletion_city",
        cityName: "city",
        postcodeName: "zipcode",
        cityInseeCodeName: "insee_code_city",
        required: "Merci de saisir votre ville",
        variant: "outlined",
    },
};

CompanyCity.propTypes = {
    /**
     * methods du useForm()
     */
    methods: PropTypes.instanceOf(Object),
    /**
     * Name du tag HTML input
     */
    name: PropTypes.string,
    /**
     * Espacement entre les lignes
     */
    rowSpacing: PropTypes.number,
    /**
     * Configuration du composant Grid
     */
    grid: PropTypes.instanceOf(Object),
    /**
     * Props Company
     */
    propsCompany: PropTypes.shape({
        /**
         * Label du champ
         */
        label: PropTypes.string,
        /**
         * Name du tag HTML input
         */
        name: PropTypes.string,
        /**
         * Name du tag HTML input contenant le nom de l'entreprise
         */
        companyName: PropTypes.string,
        /**
         * Name du tag HTML input contenant l'adresse de l'entreprise
         */
        companyAddress: PropTypes.string,
        /**
         * Name du tag HTML input contenant le code postal de l'entreprise
         */
        companyZipcode: PropTypes.string,
        /**
         * Name du tag HTML input contenant le SIREN
         */
        sirenName: PropTypes.string,
        /**
         * Message d'erreur si le champ est requis
         */
        required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        /**
         * The variant to use
         * 'filled'
         * | 'outlined'
         * | 'standard'
         */
        variant: PropTypes.string,
    }),
    propsCompanyCity: PropTypes.shape({
        /**
         * Label du champ
         */
        label: PropTypes.string,
        /**
         * Name du tag HTML input
         */
        name: PropTypes.string,
        /**
         * Name du tag HTML input contenant le nom de la ville
         */
        cityName: PropTypes.string,
        /**
         * Name du tag HTML input contenant le code postal
         */
        postcodeName: PropTypes.string,
        /**
         * Name du tag HTML input contenant le code insee de la commune
         */
        cityInseeCodeName: PropTypes.string,
        /**
         * Message d'erreur si le champ est requis
         */
        required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        /**
         * The variant to use
         * 'filled'
         * | 'outlined'
         * | 'standard'
         */
        variant: PropTypes.string,
    }),
};

export default CompanyCity;